<fa-icon class="icon default" [icon]="['far', 'heart']" [ngClass]="{'visible': !isActive, 'disabled': disabled }"></fa-icon>
<fa-icon class="icon selected" [icon]="['fad', 'heart']" [ngClass]="{'visible': isActive, 'disabled': disabled }"></fa-icon>
